import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function OAuthCallback({ oauth, setAccessToken }) {
    // our oauth library expects a complete URL that can be passed to
    // new URL and a pathname + search doesn't cut it. But, given that we
    // just basically need that library to parse out the query string, faking
    // it here is just fine. the location from react router does not include
    // the hostname or protocol like a real location object does.
    const location = useLocation();
    const url = `https://ignored${location.pathname}${location.search}`;
    const navigate = useNavigate();

    useEffect(() => {
        oauth.completeLogin(url).then(
            ({ alliRedirect, ...response }) => {
                setAccessToken(response);
                navigate(alliRedirect);
                return null;
            },
            err => {
                console.error(err);
                // TODO actually show an error here perhaps?
                return null;
            },
        );
    }, [oauth, setAccessToken, url]);

    return null;
}
